<script>
    import error2 from "shared/Components/error2.vue";
    import assistiveText from "shared/Components/assistiveText.vue";
    
    export default {
        props: {
            "messages": Array,
            "prefix": {
                type: String,
                default: "Error: "
            },
            "topRules": {
                type: Array,
                default: () => []
            },
            "topFields": {
                type: Array,
                default: () => []
            },
            "ariaOnly": {
                type: Boolean,
                default: process.env.INLINE_ERRORS
            }
        },
        data() {
            return {
                inline: process.env.INLINE_ERRORS
            }
        },
        components: {
            error2,
            assistiveText
        },
        methods: {
            getRawErrorStrings(messages) {
                let result = messages.slice(), topFields = this.topFields, topRules = this.topRules;

                if(result.length) {
                    let parentFields = [].slice.call(this.$parent.$el.querySelectorAll("input[name],select[name],textarea[name]")).map(x => x.name);

                    //this sort will ensure that the 'top fields/rules' errors are always on top and that the rest are sorted by their order in the DOM
                    result.sort((a, b) => topRules.includes(a.rule) ? -1 : topRules.includes(b.rule) ? 1 : 
                        topFields.includes(a.field) ? -1 : topFields.includes(b.field) ? 1 : 
                        parentFields.indexOf(a.field) - parentFields.indexOf(b.field));
                }

                return result.map(x => {
                    if(typeof x === "string") {
                        return x.trim();
                    }
                    if(typeof x.msg === "string") {
                        return x.msg.trim();
                    }
                    if(typeof x.message === "string") {
                        return x.message.trim();
                    }
                    return x.toString().trim();
                });
            }
        },
        computed: {
            errorStringsRaw() {
                return this.getRawErrorStrings(this.messages);
            },
            errorStrings() {
                return this.errorStringsRaw.map(x => {
                    if(this.prefix && x.indexOf(this.prefix) === -1) {
                        return this.prefix + x;
                    }
                    return x;
                })
            },
            distinctErrors () {
                if(this.errorStrings.length) {
                    return this.errorStrings.filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                }
                return [];
            },
            ariaText() {
                let errors = this.errorStringsRaw;
                if(errors.length) {
                    let countstring = errors.length === 1 ? `there is an error.` : `there are ${errors.length} errors.`;
                    return `${countstring} ${errors.join(',  ')}`;
                }
                return '';
            },
            noFieldErrors() {
                return this.getRawErrorStrings(this.messages.filter(x => x.field === ""));
            }
        }
    }
</script>

<template>
    <div ref="errorList" v-if="distinctErrors && distinctErrors.length" class="error-container" :class="{ errors: !!this.errorStrings.length, grouped: !inline }">
        <assistive-text :value="ariaText"></assistive-text>
        <error2 v-if="!ariaOnly" v-for="(error, index) in distinctErrors" :key="index" aria-hidden="true">
            <span v-html="error"></span>
        </error2>
        <error2 v-else v-for="(error, index) in noFieldErrors" :key="index" aria-hidden="true">
            <span v-html="error"></span>
        </error2>
    </div>
</template>

<style lang="less" scoped>
    .grouped {
        padding-top: 65px;
        margin-top: -65px;
    }
</style>